﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadBlockArrayField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadBlockArrayField, eOutputFieldType.cadBlockArray)
export class CadBlockArrayField extends OutputField implements ICadBlockArrayField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public columnSpacing: number;
    public filePath: string;
    public flipX: boolean;
    public flipY: boolean;
    public insertionPointX: number;
    public insertionPointY: number;
    public insertionPointZ: number;
    public layer: string;
    public numColumns: number;
    public numRows: number;
    public password: string;
    public rotation: number;
    public rowSpacing: number;
    public xScale: number;
    public yScale: number;
    public zScale: number;
}
